module.exports = __webpack_public_path__ + "platform-web/static/media/cancel.25f81316.svg";